






import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class ComputedTime extends Vue {
  @Prop()
  private value!: number;

  get time() {
    return this.value || this.$store.state.time;
  }
}
